
import React from 'react';
import { motion } from "framer-motion";

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};

export const SkillsStepContent: React.FC = () => {
  return (
    <motion.div 
      className="p-5 bg-web3-blue/10 rounded-lg mt-4 border border-web3-blue/30 flex-grow"
      variants={itemVariants}
    >
      <h4 className="font-medium text-web3-green mb-3 text-lg">Skill Categories</h4>
      <div className="grid grid-cols-2 gap-4">
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Technical</h5>
          <p className="text-white/80">Improves efficiency and uptime</p>
        </div>
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Business</h5>
          <p className="text-white/80">Improves profit margins</p>
        </div>
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Operations</h5>
          <p className="text-white/80">Reduces energy costs and improves efficiency</p>
        </div>
        <div className="p-3 bg-web3-blue/20 rounded-md">
          <h5 className="font-medium text-bitcoin-accent mb-1">Leadership</h5>
          <p className="text-white/80">Improves profit margins and uptime</p>
        </div>
      </div>
    </motion.div>
  );
};
